
import * as amplitude from '@amplitude/analytics-node';

amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_KEY);    

export const logAmplitudeGeneralSSR = async (eventType, eventProperties = {}, context) => {
  try {
    await amplitude.track({
      event_type: eventType,
      user_properties: { landing_url: process.env.NEXT_PUBLIC_CLIENT_HOST + context.req.url}
    }, eventProperties, {user_id: process.env.NEXT_PUBLIC_AMPLITUDE_USER_ID_FOR_GENERAL_EVENTS ?? 'FE_SSR'});
  } catch (error) {
    console.error('Error logging event:', error);
  }
}
